export default {
  URL: 'https://maps.google.com/maps?q=51.531972,-0.129056&ll=51.531972,-0.129056&t=&z=17&ie=UTF8&iwloc=&output=embed'
}
